// extracted by mini-css-extract-plugin
export default {"root":"RecordListModal_root__F6Vzs","chatWrapper":"RecordListModal_chatWrapper__cxtzp"};